import { Header } from "@general-backoffice/core/index";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Col, Container, Row } from "reactstrap";

import { referrerEndpoints } from "../../../../api";
import useClaimHistory from "../../../../components/payouts/hooks/useClaimHistory";
import PayoutsTableCard from "../../../../components/payouts/PayoutsTableCard";
import { ClaimFlowModal } from "../../../../components/referrer/claim";
import DiscountWalletCard from "../../../../components/referrer/DiscountWalletCard";
import PartnerRecurringRequirementsCard from "../../../../components/referrer/partner/PartnerRecurringRequirementsCard";
import PayoutWalletCard from "../../../../components/referrer/partner/PayoutWalletCard";
import useUser from "../../../../components/users/hooks/useUser";
import WarningBanner from "../../../../components/warnings/WarningBanner";
import useFetch from "../../../../hooks/useFetch";
import type { RootState } from "../../../../redux/reducers/session/state";
import isVipOrZeroPriceTier from "../../../../utils/isVipOrZeroPriceTier";

// let hasShownPopUp = false;

const ReferrerPartner = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("dashboard", { keyPrefix: "referrerPartner" });
  const sessionState = useSelector((state: RootState) => state.sessionState);
  const [showClaimFlow, setShowClaimFlow] = useState(false);

  // const tncAccepted = sessionState.user?.hasAcceptedAffiliateTnC
  const userBlocked = sessionState.user?.isBlockedFromAffiliate;
  const isVIP = isVipOrZeroPriceTier(sessionState?.user);

  const { state: discountWallet, isLoading: isLoadingDiscountWallet } = useFetch(() =>
    referrerEndpoints.getDiscountWallet().then(({ data }) => data)
  );

  const {
    state: payoutWallet,
    isLoading: isLoadingPayoutWallet,
    refresh: requestPayoutWallet,
  } = useFetch(() => referrerEndpoints.getPayoutsWallet().then(({ data }) => data));

  const {
    state: recurringRequirements,
    isLoading: isLoadingRecurringRequirements,
    // refresh: requestRequirementsToAmbassador
  } = useFetch(() => referrerEndpoints.getRecurringRequirements().then(({ data }) => data));

  // // Open info modal on entering if has no referrals
  // useEffect(() => {
  //   if (!hasShownPopUp && referrals?.length) hasShownPopUp = true;
  //   if (!hasShownPopUp && !isLoadingReferrals && !referrals?.length) {
  //     setIsOpenInfoModal(true)
  //     hasShownPopUp = true;
  //   }
  // }, [isLoadingReferrals, !referrals?.length])

  const { claims, refresh: refreshClaims, isLoading: isLoadingClaims } = useClaimHistory();

  const { user } = useUser("me", {
    params: {
      populate: ["taxProfile"],
      fields: [],
    },
  });

  return (
    <>
      {/* <InfoModal
        isOpen={isOpenInfoModal && !isOpenPartnerInfoModal && !isOpenTnCModal}
        close={() => setIsOpenInfoModal(false)}
      /> */}

      {/* New Tax Compliance Claim Flow */}
      <ClaimFlowModal
        isOpen={showClaimFlow}
        onClose={() => setShowClaimFlow(false)}
        onSuccess={() => {
          setShowClaimFlow(false);
          requestPayoutWallet();
          refreshClaims();
        }}
        onRefresh={refreshClaims}
      />

      {/* <CreateReferralCodeModal
        referralCode={referralCodeToCreate}
        close={() => setReferralCodeToCreate(null)}
        setReferralCode={setReferralCodeToCreate}
        isLoading={isLoadingReferralCodeToCreate}
        create={() => {
          createReferralCodeToCreate()
            .then(() => {
              requestReferralCodes()
              setReferralCodeToCreate(null)
            })
        }}
      /> */}

      <Header.BreadCrumb
        color="secondary"
        isDark={false}
        // buttons={[
        //   {
        //     children: <i className="fas fa-info-circle"></i>,
        //     color: "default",
        //     size: "md",
        //     className: "shadow-none position-absolute",
        //     style: { transform: "translateY(-50%)" },
        //     onClick: () => setIsOpenInfoModal(true)
        //   }
        // ]}
      />
      <Container className="mt--6" fluid>
        <Row>
          <Col xs={12} md={6}>
            {userBlocked && (
              <div style={{ marginBottom: 30 }}>
                <WarningBanner
                  title={t("userBlockedWarning.title")}
                  text={
                    <Trans
                      t={t}
                      i18nKey={"content"}
                      components={[
                        <a key="0" href="mailto:customer@investhinks.com">
                          customer@investhinks.com
                        </a>,
                      ]}
                    />
                  }
                  type={"danger"}
                />
              </div>
            )}
            <Row>
              <Col>
                <PayoutWalletCard
                  payout={payoutWallet}
                  isLoading={isLoadingPayoutWallet}
                  onClaim={() => {
                    if (user?.taxProfile) {
                      // User has tax profile - use new claim flow
                      setShowClaimFlow(true);
                    } else {
                      // No tax profile - redirect to billing settings
                      navigate("/settings/billing");
                    }
                  }}
                />
              </Col>
              {!!discountWallet?.availableRewards?.length && (
                <Col xs={12} md={6} className="h-100">
                  <DiscountWalletCard
                    amount={discountWallet?.balance}
                    unused={discountWallet?.availableRewards?.reduce((sum, r) => sum + (r.amount || 0), 0) ?? 0}
                    isLoading={isLoadingDiscountWallet}
                  />
                </Col>
              )}
            </Row>
          </Col>
          {!isVIP && (
            <Col xs={12} md={6}>
              <PartnerRecurringRequirementsCard
                requirements={recurringRequirements?.requirements}
                isLoading={isLoadingRecurringRequirements}
              />
            </Col>
          )}
          <Col xs={12}>
            <PayoutsTableCard
              title={t("payoutsTableTitle")}
              claims={claims}
              filtersToShow={["downloadSelected"]}
              isLoading={isLoadingClaims}
              onClaimProcessed={refreshClaims}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ReferrerPartner;
